export default {
    INIT: "INIT",
    CLEAN_UP: "CLEAN_UP",

    BACK_TO_STEP_0: "BACK_TO_STEP_0",
};
